import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { SiteGroupsService } from '@services/site-groups.service';
import { Site } from '@classes/site';
import { SiteGroup } from '@classes/site-group';

@Component({
  selector: 'app-site-group-edit',
  templateUrl: './site-group-edit.component.html',
  styleUrls: ['./site-group-edit.component.scss'],
})
export class SiteGroupEditComponent
  extends FormEditBaseComponent
  implements OnInit
{
  @Input() siteGroup: SiteGroup;
  @Input() sites: Site[] = [];

  stringMaxLength = 50;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private siteGroupsSrv: SiteGroupsService,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initForm();
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.siteGroup) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const siteGroupCopy: SiteGroup = JSON.parse(JSON.stringify(this.siteGroup));
    siteGroupCopy.name = this.editForm.value.name;
    siteGroupCopy.siteIds = this.getSelectedSiteIds();
    siteGroupCopy.allowOtherAddress = this.editForm.value.allowOtherAddress;

    this.siteGroupsSrv
      .put(siteGroupCopy)
      .subscribe(() => (this.isLoading = false));
  }

  private create(): void {
    this.siteGroup = new SiteGroup(
      this.editForm.value.name,
      this.getSelectedSiteIds(),
      this.editForm.value.allowOtherAddress,
    );

    this.siteGroupsSrv.post(this.siteGroup).subscribe(
      () => (this.isLoading = false),
      () => (this.siteGroup = null),
    );
  }

  private getSelectedSiteIds(): string[] {
    return (this.editForm.value.sites as Site[]).map((site) => site.id);
  }

  private initForm(): void {
    let name = '';
    let selectedSites: Site[] = [];
    let allowOtherAddress = true;

    if (this.siteGroup) {
      name = this.siteGroup.name;
      selectedSites = this.siteGroup.sites || [];
      allowOtherAddress = this.siteGroup.allowOtherAddress ?? true;
    }

    this.editForm = this.fb.group({
      name: [
        name,
        [Validators.required, Validators.maxLength(this.stringMaxLength)],
      ],
      sites: [selectedSites, Validators.required],
      allowOtherAddress: [allowOtherAddress],
    });
  }
}
